module.exports = __webpack_public_path__ + "img/27e786c.png";